import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { KeyedRow } from '../../components/KeyedRow';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { PharmacyFirstRow } from './components/PharmacyFirstRow';
import type { PharmacyFirstDto } from './types/PharmacyFirstDto';

export function PharmacyFirst() {
	const { organisation } = useParams();
	const filter = useFilter();
	const pagination = usePagination();

	const pharmacyFirstQuery = queryWithFilterAndPages<PharmacyFirstDto[]>(
		`${organisation}/pharmacy-first/all`,
		filter.value,
		pagination.value,
	);

	const pharmacyFirstCountQuery = queryWithFilter<number>(
		`${organisation}/pharmacy-first/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader title={'Pharmacy First'} filter={filter} filterOnSameLine />
			<DataTable
				pagination={pagination}
				totalItems={pharmacyFirstCountQuery.data?.value ?? 100}
				isRowsLoading={pharmacyFirstQuery.isLoading}
				isPaginationLoading={pharmacyFirstCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Operator'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Opportunities'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Taken'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Rejected'} />
						</Table.Th>
						<Table.Th w={'6vw'}>
							<Title label={'Details'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{pharmacyFirstQuery.data?.value.map((pharmacyFirst) => (
						<PharmacyFirstRow
							pharmacyFirst={pharmacyFirst}
							filter={filter.value}
						/>
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
